<template>
  <div id="app">
    <div v-if="message" class="alert alert-danger">
      {{ message }}
    </div>
    <div class="mb-3">
      <div class="alert alert-info">
        <details>
          <summary><span style="font-weight: bold">How to use?</span></summary>
          PDB file renumbering and 3D alignment tool.
          <br>
          1. Upload your PDB file and press "Generate Lbl File" button. The file will be downloaded
          automatically.
          <br>
          2. Edit the LBL file. The file contains complete list of all elements (amino-acid residues, ions,
          ligands
          and water molecules) in the original order. DO NOT modify this column! You only need to type
          in the second column the chain labels and residues numbers for beginning of the segments in
          the corresponding positions. The elements between your labels will be relabeled sequentially.
          Do not type residue numbers for chains "I" (ions), "W" (waters) and "L" (ligands). The elements
          in these chains will be automatically numbered sequentially. Examples of LBL files can be
          downloaded from "LBL files examples".
          <br>
          3. Upload the edited LBL file. If you need both re-labeling and 3D-alignment, click "Perform 3D
          alignment". Click "Renumber" button. The resulting file will be downloaded automatically.
          <br>
          <h6 class="mt-3">Examples</h6>
          <ul>
            <li><a href="/lbl/6dm0.lbl">6dm0.lbl</a></li>
            <li><a href="/lbl/7cn1.lbl">7cn1.lbl</a></li>
            <li><a href="/lbl/2q6a.lbl">2q6a.lbl</a></li>
            <li><a href="/lbl/5xsy.lbl">5xsy.lbl</a></li>
            <li><a href="/lbl/5x0m.lbl">5x0m.lbl</a></li>
            <li><a href="/lbl/6bcl.lbl">6bcl.lbl</a></li>
            <li><a href="/lbl/6rv3.lbl">6rv3.lbl</a></li>
          </ul>
        </details>
      </div>
    </div>
    <form @submit.prevent="handleSubmit" enctype="multipart/form-data">
      <div class="mb-3">
        <label for="pdbFile" class="form-label">PDB File</label>
        <div class="input-group">
          <input class="form-control" type="file" id="pdbFile" name="pdbFile" accept=".pdb" required>
          <button class="btn btn-outline-secondary" type="button" @click="generateLabel">
            Generate Lbl File
          </button>
        </div>
      </div>
      <div class="mb-3">
        <label for="lblFile" class="form-label">Label file 
          <span class="bi bi-info-circle text-info" style="cursor:pointer;" title="Label file in lbl or slb format, each line represents start of renumbering, example
A  139  Q      A 1539
A  140  P
A  141  I
A  142  F
A  143  S
A  144  Y
A  145  A      A 1600"></span>
        </label>
        <input class="form-control" type="file" id="lblFile" name="lblFile" accept=".lbl,.slb" :required="lblRequired">
      </div>
      <div class="mb-3">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" value="1" id="align" name="align" v-model="alignChecked">
          <label class="form-check-label" for="align">
            Perform 3D alignment
          </label>
        </div>
      </div>
      <div class="mb-3">
        <button type="submit" class="btn btn-success">
          Renumber
        </button>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: 'Tools',
  data() {
    return {
      message: '',
      lblRequired: false,
      alignChecked: false
    }
  },
  methods: {
    generateLabel() {
      const pdbFile = document.getElementById('pdbFile').files[0];
      if (!pdbFile) {
        alert('Please select a PDB file first');
        return;
      }
      
      const formData = new FormData();
      formData.append('pdbFile', pdbFile);
      
      fetch('/api/tools/generate_label', {
        method: 'POST',
        body: formData
      })
      .then(response => {
        if (response.ok) {
          return response.blob();
        }
        throw new Error('Network response was not ok');
      })
      .then(blob => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.download = pdbFile.name.replace('.pdb', '.lbl');
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      })
      .catch(error => {
        console.error('Error:', error);
        alert('Error generating label file');
      });
    },
    handleSubmit(event) {
      const formData = new FormData(event.target);
      
      fetch('/api/tools/renumber', {
        method: 'POST',
        body: formData
      })
      .then(response => {
        if (response.ok) {
          return response.blob();
        }
        throw new Error('Network response was not ok');
      })
      .then(blob => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.download = 'renumbered.pdb';
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      })
      .catch(error => {
        console.error('Error:', error);
        alert('Error processing file');
      });
    },
    setRequired(required) {
      this.lblRequired = required;
    }
  }
}
</script>

